import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { DataTable, DropdownMenu } from '@3plearning/react-components';
import cloneDeep from 'lodash/cloneDeep';
import studentPropTypes from '../../../containers/participation/student/student-prop-types';
import css from './topic-tables.scss';
import {
    FIRST_VS_LATEST_TABLE_CONFIG,
    IMPROVEMENT_OPTS,
    HIGHEST_VS_LATEST_TABLE_CONFIG,
    HIGHEST_VS_LATEST,
    FIRST_VS_HIGEST_TABLE_CONFIG,
    FIRST_VS_HIGHEST,
    FIRST_VS_LATEST,
    IMPROVEMENT
} from '../../../containers/participation/student/student-constants';
import selectedImprovementsActions from '../../../containers/participation/student/selected-improvements-actions';

/**
 * Displays all topic tables for a student with their participation scores
 */

export class TopicTables extends PureComponent {
    static propTypes = {
        participationData: studentPropTypes.participationData,
        updateSelectedImprovement: PropTypes.func
    };

    constructor(props) {
        super(props);
        this.i18n = window.i18n;

        this.state = {
            // each topic table needs its own config to keep track of which improvement type is currently selected
            topicTableConfigs: {}
        };
    }

    componentWillReceiveProps(newProps) {
        const { participationData } = this.props;
        const { participationData: newParticipationData } = newProps;

        if (newParticipationData !== participationData) {
            this.setTableConfigs(newParticipationData);
        }
    }

    /**
     * Sets the table config for each individual topic table
     */
    setTableConfigs(participationData) {
        const topicTableConfigs = {};
        participationData.topicParticipations.forEach((topic, idx) => {
            topicTableConfigs[topic.id] = this.generateTopicTableConfig(
                FIRST_VS_LATEST_TABLE_CONFIG,
                topic.id,
                idx === 0
            );
        });

        this.setState({ topicTableConfigs });
    }

    generateTopicTableConfig(
        baseConfig,
        topicId,
        expand,
        option = IMPROVEMENT_OPTS[0]
    ) {
        const selectedOption = { ...option };
        selectedOption.label = (
            <span>
                {this.i18n._('Label - Improvement')}
                <br />
                {this.i18n._(selectedOption.label)}
            </span>
        );

        const tableConfig = cloneDeep(baseConfig);
        tableConfig.nestedData.collapse.expandFirst = expand;
        const improvementCol = this.getColFromConfig(tableConfig, IMPROVEMENT);
        const improvementOpts = IMPROVEMENT_OPTS.map((optionOpt) => ({
            ...optionOpt,
            label: this.i18n._(optionOpt.label)
        }));
        improvementCol.headerTransform = () => (
            <div>
                <DropdownMenu
                    options={improvementOpts}
                    selectedOption={selectedOption}
                    onSelectOption={(selected) =>
                        this.changeImprovementCol(topicId, selected)
                    }
                    className={css['improvement-dropdown']}
                />
            </div>
        );

        return tableConfig;
    }

    changeImprovementCol = (topicId, option) => {
        let baseConfig;
        switch (option.value) {
            case FIRST_VS_LATEST:
                baseConfig = FIRST_VS_LATEST_TABLE_CONFIG;
                break;
            case FIRST_VS_HIGHEST:
                baseConfig = FIRST_VS_HIGEST_TABLE_CONFIG;
                break;
            case HIGHEST_VS_LATEST:
                baseConfig = HIGHEST_VS_LATEST_TABLE_CONFIG;
                break;
            default:
        }

        const topicTableConfigs = {
            ...this.state.topicTableConfigs,
            [topicId]: this.generateTopicTableConfig(
                baseConfig,
                topicId,
                true,
                option
            )
        };
        this.setState({ topicTableConfigs });

        this.props.updateSelectedImprovement({
            topicId,
            selectedImprovement: option.value
        });
    };

    getColFromConfig = (config, colId) =>
        config.cols.find((col) => col.id === colId);

    setColNameTranslations = (tableConfig) => {
        const { emptyDataMessage, messageTopicTable } = tableConfig.nestedData;
        const i18n = this.i18n;
        tableConfig.nestedData.emptyDataMessage = i18n._(emptyDataMessage);
        tableConfig.nestedData.messageTopicTable = i18n._(messageTopicTable);
        tableConfig.cols.map((col) => {
            if (col.name) {
                col.name = i18n._(col.name);
            }
            return col;
        });
        return tableConfig;
    };

    render() {
        const { topicTableConfigs } = this.state;
        const { participationData } = this.props;

        return (
            <div className={css.component}>
                {participationData &&
                    participationData.topicParticipations.map((topic) => {
                        let tableConfig = topicTableConfigs[topic.id];
                        if (!tableConfig) {
                            return null;
                        }
                        tableConfig = this.setColNameTranslations(tableConfig);
                        const { messageTopicTable } = tableConfig.nestedData;
                        return (
                            <div className={css['topic-table']} key={topic.id}>
                                <DataTable
                                    config={tableConfig}
                                    data={[topic]}
                                />
                                <span className={css['topic-table-msg']}>
                                    {messageTopicTable}
                                </span>
                            </div>
                        );
                    })}
            </div>
        );
    }
}

/*
 * mapStateToProps - set component properties from current state provided by the Reducers
 */
function mapStateToProps(state) {
    return {
        participationData: state.participationStudent
    };
}

/*
 * mapDispatchToProps - ensure that the outputs of the Action Creators are passed to the Reducers
 */
function mapDispatchToProps(dispatch) {
    return bindActionCreators(
        {
            updateSelectedImprovement:
                selectedImprovementsActions.updateSelectedImprovement
        },
        dispatch
    );
}

export default connect(mapStateToProps, mapDispatchToProps)(TopicTables);



// WEBPACK FOOTER //
// ./components/participation-student/topic-tables/topic-tables.js